<nz-card class="glass-card cursor-pointer" (click)="emitCardClick(incident)">
    <div class="space-y-2">
        <app-trip-route [locationData]="[
                    { location: incident?.startLocation?.name, type: 'leg' },
                    { location: incident?.endLocation?.name, type: 'leg' }]">
        </app-trip-route>
        <div class="flex flex-nowrap items-center gap-x-2 overflow-x-auto overflow-y-hidden no-scrollbar">
            <i nz-icon class="text-3xl mt-0.5 -mr-1.5 -ml-1.5"
                [ngClass]="{'text-danger': incident?.priority === 3, 'text-[#FF8D0F]': incident?.priority === 2, 'text-warning': incident?.priority === 1}"
                [nzType]="'hezky:' + incident?.incident_type?.toLowerCase()" nzTheme="outline">
            </i>
            <div class="text-4xl font-normal"
                [ngClass]="{'text-danger': incident?.priority === 3, 'text-[#FF8D0F]': incident?.priority === 2, 'text-warning': incident?.priority === 1}">
                {{ feUtil.getFormattedTemp(incident?.triggered_value, incident?.incident_type?.toLowerCase()) }}
            </div>
            <div class="flex flex-col text-xs" [ngClass]="{'text-danger ': incident?.priority === 3, 'text-[#FF8D0F]': incident?.priority === 2, 'text-warning': incident?.priority === 1}">
                {{incident?.threshold_condition}} {{ feUtil.getFormattedTemp(incident?.threshold_value,incident?.incident_type?.toLowerCase()) }}
                <span> Duration: {{ incident.triggered_time | relativeTime:'card' }}</span>
            </div>
        </div>
        <div class="flex flex-wrap-reverse items-center justify-between text-xs gap-1">
            <p class="flex items-center gap-x-1">
                <i nz-icon nzType="calendar" nzTheme="outline" class="text-blue-400"></i>
                <span class="font-medium text-gray-700">Triggered Time:</span>
                <span class="text-gray-500">{{ incident?.triggered_time | gDate }}</span>
            </p>
            <p class="flex items-center gap-x-1">
                <span class="font-medium text-gray-700">Trip ID:</span>
                <span class="text-gray-500">{{incident?.trip_id || '-'}}</span>
            </p>
        </div>
    </div>
</nz-card>